
const MissionSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Our Mission: Making Global Growth Accessible
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We started this company because we saw too many brilliant small businesses 
              hitting invisible walls when trying to expand internationally. Complex regulations, 
              confusing logistics, and overwhelming technology barriers were keeping amazing 
              products from reaching customers who needed them.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Today, we've simplified the path to global expansion. Our proven framework 
              has helped hundreds of small businesses break through those barriers and 
              build thriving international operations.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-teal-600 mb-2">400%</div>
                <div className="text-sm text-gray-600">Average Revenue Growth</div>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-teal-600 mb-2">12+</div>
                <div className="text-sm text-gray-600">Countries Expanded To</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/5c7f0e814456c320550e99fdff5a03d4.jpg"
              alt="Global business strategy"
              className="rounded-lg shadow-lg w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
